<div
  class="grid-wrapper d-flex flex-column flex-grow-1"
  [class.maximized]="!isMinimized"
  >
  <div class="d-flex mb-3 align-items-center">
    @if (title) {
      <div class="title">{{ title }}</div>
    }
    <div class="ms-auto"></div>
    @for (gridAction of gridActions; track gridAction) {
      @if (gridAction.icon) {
        <i
          class="action feather"
          (click)="gridAction.onAction()"
          [title]="gridAction.title"
          [class]="gridAction.class"
        ></i>
      }
      <button
        class="btn btn-sm btn-outline-primary ms-2 d-flex align-items-center"
        (click)="gridAction.onAction()"
        >
        <i class="feather icon-btn m-0 me-2" [class]="gridAction.class"></i>
        <span>{{ gridAction.description }}</span>
      </button>
    }
    @if (canDownloadExcel) {
      <i
        class="action feather icon-download"
        (click)="downloadExcel()"
        title="scarica"
      ></i>
    }
    @if (isMinimized) {
      <i
        class="action feather icon-maximize-2"
        (click)="maximize()"
        title="massimizza"
      ></i>
    }

    @if (!isMinimized) {
      <i
        class="action feather icon-minimize-2"
        (click)="minimize()"
        title="minimizza"
      ></i>
    }
  </div>

  <ellf-data-grid
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [items]="items"
    [canView]="canView"
    [canEdit]="canEdit"
    [canDelete]="canDelete"
    [customActions]="customActions"
    [editVisible]="editVisible"
    [deleteVisible]="deleteVisible"
    [viewVisible]="viewVisible"
    (view)="view.emit($event)"
    (edit)="edit.emit($event)"
    (delete)="delete.emit($event)"
    >
  </ellf-data-grid>
  @if (paged && totalRows > 0) {
    <div class="d-flex align-items-center mt-1">
      <div>
        Risultati:
        {{ firstRecord + ' - ' + lastRecord }}
        di {{ totalRows }}
      </div>
      <ngb-pagination
        class="d-flex justify-content-end ms-auto"
        [page]="currentPage"
        (pageChange)="onPageChange($event)"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="false"
        [collectionSize]="totalRows"
        size="sm"
      ></ngb-pagination>
      <!-- <div class="text-right ms-3">
      Page Size:
      <select [formControl]="pageSizeControl">
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div> -->
  </div>
}
</div>
